import { AxiosInstance } from 'axios'
import { AnalysisApi } from './analysis-api'
import { ClientAdminApi } from './client-admin-api'
import { DashboardApi } from './dashboard-api'
import { MomentsApi } from './moments-api'
import { ConversationsApi } from './conversations-api'
import { CommentaryApi } from './commentary-api'
import { IngestionApi } from './ingestion-api'
import { createTranscriptionV2Api } from '@/contexts/transcription/src/transcription.api'
import { LanguageApi } from './language-api'
import { TranscriptionManagerApi } from './transcription-manager-api'

export type BasePaths = Record<string, string>

export default (client: AxiosInstance, basePaths: BasePaths) => ({
  analysis: new AnalysisApi(client, basePaths.analysis),
  clientAdmin: new ClientAdminApi(client, basePaths.clientAdmin),
  dashboard: new DashboardApi(client, basePaths.dashboard),
  moments: new MomentsApi(client, basePaths.moments),
  conversations: new ConversationsApi(client, basePaths.conversations),
  commentary: new CommentaryApi(client, basePaths.commentary),
  ingestion: new IngestionApi(client, basePaths.ingestion),
  transcriptionV2: createTranscriptionV2Api(client, basePaths.transcription),
  transcriptionManager: new TranscriptionManagerApi(
    client,
    basePaths.transcriptionManager
  ),
  languages: new LanguageApi(client, basePaths.transcription)
})
